import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum HopeFiltersEnum {
    HUV1 = 3,
    HUV2 = 4,
    SFV = 5
}

export class HopeFiltersClass extends EnumWithDescription<HopeFiltersEnum> {
    public readonly enum = "HopeFilters";
    public readonly enumName: string = "HopeFilters";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<HopeFiltersEnum>> = new Map([
        [
            "HUV1",
            {
                value: HopeFiltersEnum.HUV1,
                name: "HUV1"
            }
        ],
        [
            "HUV2",
            {
                value: HopeFiltersEnum.HUV2,
                name: "HUV2"
            }
        ],
        [
            "SFV",
            {
                value: HopeFiltersEnum.SFV,
                name: "SFV"
            }
        ]
    ]);
}

export const HopeFilters = new HopeFiltersClass();
